import React from 'react'
import Modal from 'react-modal'
import SlidingPane from 'react-sliding-pane'
import 'react-sliding-pane/dist/react-sliding-pane.css'

class HelpHtml extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			visible: false
		};
	}

	display = () => {
		this.setState({
			visible: true
		});
	}

	handleOnClose = () => {
		this.setState({ visible: false });
	}

	componentDidMount() {
		Modal.setAppElement(this.container);
	}

	render() {
		return (
			<div ref={ref => this.container = ref}>
				<SlidingPane
					className='help-container'
					overlayClassName='help-overlay'
					isOpen={this.state.visible}
					width='650px'
					from='left'
					title='Help'
					onRequestClose={this.handleOnClose}>
					<div dangerouslySetInnerHTML={{ __html: this.props.content }} />
				</SlidingPane>
			</div>)
	}
}

export default HelpHtml;


// WEBPACK FOOTER //
// ./src/layouts/main/sidebar/help/HelpHtml.js